import { ModuleIdEnum } from '../../enums/moduleId';
import { HttpClient } from '../HttpClient';
import { RouteAccessDataInterface } from '../../types/getRouteAccessInterface';

const DEFAULT_MODULE_ID = ModuleIdEnum.attendanceLogs;
export const GetRouteAccess = async (moduleId = DEFAULT_MODULE_ID): Promise<RouteAccessDataInterface> => {
  try {
    const { data } = await HttpClient.get('api/users/routeaccess', {
      params: { ModuleId: moduleId },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
